import { filterObjectStore, queryFilter } from 'Redux/Query/System';

export const getProcessStatementQuestions = (state, filter = null) => {
  if(filter === null) {
    filter = queryFilter({sorting: { by: 'sorting', order: 'ASC' }})
  }

  return filterObjectStore(state.processStatementQuestion.questions, filter);
};
